import { LoadSpinner } from '@calizahq/react-components-v2'
import styled from '@emotion/styled'
import { Table } from '@shared/components'
import React, { useMemo } from 'react'

import { NoResults } from '@/components'
import { useMobile } from '@/hooks'
import { HomeIssue } from '@/types/HomeIssue'

import { HomeIssueListColumns } from './HomeIssue.data'
import { HomeMobileIssueCard } from './HomeMobileIssueCard'

type Props = {
  className?: string
  data: HomeIssue[]
  isLoading: boolean
  refetchOnSuccess: () => void
}

export const HomeIssues = ({ className = '', data, isLoading, refetchOnSuccess }: Props) => {
  const { isTablet } = useMobile()

  const columns = useMemo(() => {
    return HomeIssueListColumns(refetchOnSuccess)
  }, [refetchOnSuccess])

  if (!isLoading && (!data || data.length === 0)) return null

  return (
    <div className="flex w-full flex-col py-4">
      <div className="mb-2 flex w-full items-center justify-between md:mb-4 md:flex-row">
        <h2 className=" text-header-md leading-120">Known Issues</h2>
      </div>
      {isLoading ? (
        <div className="flex h-20 w-full items-center justify-center">
          <LoadSpinner className="icon-secondary" isCurrentColor={true} size={2} />
        </div>
      ) : (
        <>
          {isTablet ? (
            <>
              {(data &&
                data.map((homeIssue, index) => (
                  <HomeMobileIssueCard homeIssue={homeIssue} key={index} refetchOnSuccess={refetchOnSuccess} />
                ))) || <NoResults />}
            </>
          ) : (
            <Table className={className} columns={columns as any} data={data} />
          )}
        </>
      )}
    </div>
  )
}

export const ContainerStyled = styled.div`
  padding: 1rem 0;
  display: grid;
  grid-area: auto / auto / auto / auto;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(1, 1fr);
    gap: 1rem;
  }
`
